export const FLAGS = {
  APP_PHASE_2: "APP_PHASE_2",
  APP_PHASE_2_ONBOARD: "APP_PHASE_2_ONBOARD",
  APP_PHASE_2_ONBOARD_ENTERTAINMENT: "APP_PHASE_2_ONBOARD_ENTERTAINMENT",
  WEB_LOYALTEE: "WEB_LOYALTEE",
  WEB_POPUP: "WEB_POPUP"
};
